import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=6d4cd66b"
import script from "./editGroup.vue?vue&type=script&lang=js"
export * from "./editGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4cd66b')) {
      api.createRecord('6d4cd66b', component.options)
    } else {
      api.reload('6d4cd66b', component.options)
    }
    module.hot.accept("./editGroup.vue?vue&type=template&id=6d4cd66b", function () {
      api.rerender('6d4cd66b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsGrouped/editGroup.vue"
export default component.exports